import styled from 'styled-components';
import { Trans } from 'react-i18next';

import { useCheckoutContext } from 'checkout/providers/CheckoutContextProvider';
import { GiftCard } from 'checkout/components/Payment/GiftCard';

const TP = 'checkout.components.Payment.ApplePay';

export const ApplePay = () => {
  const { applePayAvailable, ExpressPayButton } = useCheckoutContext();

  if (!applePayAvailable) return null;

  return (
    <>
      <GiftCard />
      <p>
        <Trans
          i18nKey={`${TP}.applePayTerms`}
          defaults="By proceeding, you confirm you have read and agree to the <br><purchasePolicyLink>Purchases and Returns Policy</purchasePolicyLink>."
          components={{ purchasePolicyLink: <ApplePay.Link href="/returns" target="_blank" /> }}
        />
      </p>

      <ApplePay.Wrapper>
        <ApplePay.ButtonBackground>
          <ExpressPayButton data-qa="checkout_apple_pay_payment_submit" />
        </ApplePay.ButtonBackground>
      </ApplePay.Wrapper>
    </>
  );
};

ApplePay.Wrapper = styled.div`
  width: 100%;
  margin-top: 32px;
  p {
    margin-bottom: 16px;
  }
  button {
    margin-top: 48px;
  }
`;

ApplePay.ButtonBackground = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.black};
  border-radius: 0;
  height: 42px;

  > div {
    padding-top: 5px;
  }
`;

ApplePay.Link = styled.a`
  text-decoration: underline;
`;
